module.exports = {"data":{"markdownRemark":{"html":"<p>The Dashboard has a fully integrated lead management system to track a sales teams or individuals leads.</p>","frontmatter":{"date":"September 04, 2018","path":"/leads","title":"Leads"}}},"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/leads.json
// module id = 325
// module chunks = 126990158671820